import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const retailerCollectionsV3AccessControl: DomainAccessControlConfig = {
  permissions: [Permission.RetailerCollectionsRetailerCollectionsV2],
  minICPlatformVersion: ICPlatformVersion.r2025_01_0,
}
